module.exports = __webpack_public_path__ + "img/1481072879.297c46f4.jpg";